import React from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import {
  getPodcast,
  podcastStatusChanged,
} from "../../features/slices/poadcast";
import { toastService } from "../../utils/toastify";

const DeletePodcast = ({ setUpdateState, id }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    setUpdateState((prev) => ({ ...prev, deleteModal: false }));
  };
  const handleDelete = () => {
    dispatch(podcastStatusChanged({ id, status: "DELETED" })).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getPodcast());
        handleClose();
        toastService.success("Episode deleted successfully");
      } else {
        toastService.error(res?.payload?.message);
        console.log(res);
      }
    });
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Decline">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Delete</h3>
          <p>Are you sure you want to delete this Podcast ?</p>
          <h4>
            <a onClick={handleClose}>no</a>
            <a onClick={handleDelete}>Yes</a>
          </h4>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePodcast;
